<template>
  <div class="animated-emoji">
    <div class="animated-emoji-inner">
      <picture>
        <source class="stretch" :srcset="`https://fonts.gstatic.com/s/e/notoemoji/latest/${notoEmojiId}/512.webp`"
          type="image/webp">
        <img class="stretch" :src="`https://fonts.gstatic.com/s/e/notoemoji/latest/${notoEmojiId}/512.gif`" alt="😆"
          width="32" height="32">
      </picture>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  notoEmojiId: String
});

</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.animated-emoji {
  align-self: center;

  &-inner {
    width: 100%;
    padding-top: 100%;
    position: relative;
  }

  picture {
    width: 100%;
    height: 100%;

    source,
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
